import { IoCarOutline, IoChevronBack } from "react-icons/io5";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Tabbar } from "../compornents/Tabbar";
import { Analytics } from '../compornents/Analytics';
import { Post } from '../compornents/Post';
import { toast } from 'react-toastify';
import { useModal } from 'react-hooks-use-modal';
import { TailSpin } from 'react-loading-icons';

export const Cleaning = () => {
  // {order_id: "1234"}
  const navigate = useNavigate();
  // 戻る
  const back = () => {
    navigate(-1);
  };
  // 初期化
  const [company, setCopany] = useState(null); // 初期値はnullである必要あり
  const [LoadingModal, openLoadingModal, closeLoadingModal] = useModal('root', {
//    preventScroll: true //これはオプション。デフォルトはfalse
  });
  useEffect(() => {
    // ページトップ
    setTimeout(() => {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      window.scrollTo(0, 0); // 念のため併用
    }, 10);
    let unmounted = false;
    // 注文情報取得
    (async () => {
      openLoadingModal();
      let response_data = await Post('post', '/company/index.php', {});
      // console.log(response_data);
      if (response_data.result === 1) {
        if(!unmounted){
          setCopany(response_data);
        }
      } else {
        // エラー
        toast.error(response_data.error_message);
      }
      closeLoadingModal();
    })();
    //クリーンアップ関数を返す

    return () => { unmounted = IoCarOutline};

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="App">
      <div className="Cleaning">
        <Analytics title="担当クリーニング店" />
        <div className="toolbar mb-3">
          <div className="toolbar_left div_btn" onClick={back} >
            <IoChevronBack />
          </div>
          <div className="toolbar_center">
            担当クリーニング店
          </div>
          <div className="toolbar_right">
          </div>
        </div>
        <div className="m-4">
          <div className="mb-3">
            <div className="h5 mb-2">
              店名
            </div>
            <div className="">
              {company?.gcompany.name}
            </div>
          </div>
          <div className="mb-3">
            <div className="h5 mb-2">
              所在地
            </div>
            <div className="">
              〒{company?.gcompany.zip}
            </div>
            <div className="">
              {company?.gcompany.pref}{company?.gcompany.add1}{company?.gcompany.add2}{company?.gcompany.add3}{company?.gcompany.add4}
            </div>
          </div>
          <div className="mb-3">
            <div className="h5 mb-2">
              電話受付時間
            </div>
            <div className="">
              {company?.gcompany.contact}
            </div>
          </div>
          <div className="mb-3">
            <div className="h5 mb-2">
              定休日
            </div>
            <div className="">
              {company?.gcompany.holiday}
            </div>
          </div>
          {company && (
            <img src={company?.gcompany.img} className="w-100" alt="cleaning" />
          )}
        </div>
        <Tabbar menu="account" />
      </div>

      <LoadingModal>
        <div className="modal rounded text-center pb-4 pl-4 pr-4 m-1">
          <button onClick={closeLoadingModal} className="hide">閉じる</button>
          <div >
            <TailSpin stroke="#000" />
          </div>
          <div className="">
            <div className="">
              処理中です
            </div>
          </div>
        </div>
      </LoadingModal>
    </div>
  );
}
